import Vue from 'vue';
import Vuex from 'vuex';
import login from './login';
import common from './common';
import tree from './common/tree';
import processes from './common/processes';
import configTree from './config/tree';
import linking from './config/linking';
import runtask from './runtask/runtask';
import multitask from './runtask/multitask';
import reference from './reference/reference';
import configTasks from "./config/configTasks";
import cron from "./cron/cron";
import cronTemplates from "./cron/templates";
import cronPackets from "./cron/packets";


Vue.use(Vuex);

export const store = new Vuex.Store({
	modules: {
		login,
		common,
		tree,
		processes,
		configTree,
		linking,
		runtask,
		multitask,
		reference,
		configTasks,
		cron,
		cronTemplates, 
		cronPackets,
	}
});
